<template>
    <div>
      
        <v-container>
            <v-form>

                <v-row>
                    <h2 class="pb-5">
                        {{ this.parentObject.pageTitle }}
                        <span class="page_title_value">
                            {{ this.parentObject.pageTitleValue }}
                            </span></h2>
                </v-row>

                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4">
                            <v-autocomplete
                                outlined
                                :label= "this.$t('ircasemaintenance.selectcaseid')"
                                type="text"
                                ref="ircaseid"
                                :rules="[rules.required]"
                                v-model="formData.ircaseid"
                                dense
                                :items="caseIDList"
                                @change="changeIRCaseHandler(formData.ircaseid)"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="2" sm="2" class="pb-n4" align="center">
                            <v-avatar size="40" tile>
                                <img
                                :src="`${publicPath}images/print_letter.png`"
                                @click="clickLetterHandler(2)"
                                />
                            </v-avatar>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.incidentshortdesc')"
                                type="text"
                                :rules="[rules.required]"
                                v-model="formData.shortdesc"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.incidentdate')"
                                type="text"
                                ref="incidentdate"
                                v-model="formData.incidentdate"
                                dense
                                readonly
                                append-icon=""
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col col="12" sm="12" class="pb4-4">
                            <app-table 
                                v-bind:parentObject = "{
                                    tabHeader: this.tabHeader,
                                    detailItem: this.formData.casesubdetail
                                }"

                                v-on:input="addItemHandler"
                            />
                        </v-col>
                    </v-row>  

                     <!-- <v-row class="blue--text ">
                            <h3>Case Subject Supporting Document Control </h3>
                        </v-row> -->

                <!-- <v-row >
                    <v-col col="12" sm="12" class="pb4-4">
                        <app-table2 
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader2,
                                detailItem: this.formData.documentdetail
                            }"
        
                            v-on:input="addItemHandler2"
                        />
                    </v-col>
                </v-row>  -->
                </v-container>

                <app-formbuttons
                    v-bind:EditBool = this.parentObject.isEdit
                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler"
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler"
                 />
            </v-form>
        </v-container>
        <div v-if="isPrint">
            <app-print
            v-bind:parentObject="{
                pageTitleValue: this.pageTitleValue,
                isPrint: this.isPrint,
                // ircaseid: this.formData.ircaseid,
                classId: this.classId,
                templatetypeid: this.templatetypeid
            }"
            v-on:print="printHandler($event)"
            v-on:cancelPrint="isPrint = !isPrint"
            />
      </div>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';
import PrintDialog from "../../../components/common/PrintDialog";
import jsPDF from "jspdf";
//import CRUDTable2 from './CRUDTable2';
import moment from "moment";


export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-table": CRUDTable,
        "app-print": PrintDialog,
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,
            rules: {
                required: value => !!value || 'Required.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            pageTitle: '',
            pageTitleValue: '',
            formData: {
                id: this.parentObject.data.id,
                casesubdetail: this.parentObject.data.casesubdetail,
                ircaseid: this.parentObject.data.ircaseid,
                shortdesc: this.parentObject.data.shortdesc,
                longdesc: this.parentObject.data.longdesc,
                incidentdate: this.parentObject.data.incidentdate,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },
            tabHeader: [
                { text: this.$t('payeeinputprocess.action'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.staffname'), value: 'psnname', width: '200px', sortable: false},
                { text: this.$t('columns.staffcode'), value: 'staffcode', width: '200px', sortable: false },
                { text: this.$t('attendancereportbypeiordbycompanyreport.companyname'), value: 'compnyname', width: '200px', sortable: false },
                { text: this.$t('ircasemaintenance.invllevel'), value: 'involvementlvlcode', width: '200px', sortable: false },
                { text: this.$t('ircasemaintenance.terminate'), value: 'termination', width: '200px', sortable: false },
                { text: this.$t('columns.effectivedate'), value: 'effectivedate', width: '200px', sortable: false },
            ],

            // tabHeader2: [
            //    { text: 'ACTION', value: 'action', width: '100px', sortable: false},
            //    { text: 'DOCUMENT DESCRIPTION', value: 'attachdesc', width: '200px', sortable: true},
            // ],

            caseIDItems: [],
            caseIDList: [],

            selected: [],

            hidetable: false,

            errMsg: '',
            isErr: false,
            editMode: false,
            loading: false,
            isPrint: false,
            classId: null,
            templatetypeid: 3, // IR 
            letterTemplateDetails: {},
            search: this.parentObject.searchnew
        }
    },

    methods: {     
        clickLetterHandler(id) {
            const vm = this;
            vm.isPrint = !vm.isPrint
            vm.classId = id
        },

        addItemHandler($event) {
            this.formData.casesubdetail =$event
        },

        loadCaseID() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/ircasemaintenance/all'
            })
            .then(res => {
                if (res.data.rec.length == 0) return false
                vm.caseIDItems = res.data.rec;

                for (let i = 0; i < vm.caseIDItems.length; i++) {
                    vm.caseIDList.push({
                        text: vm.caseIDItems[i].caseid,
                        value: vm.caseIDItems[i].id,
                    });
                }

                if (this.formData.ircaseid) {
                    this.changeIRCaseHandler(this.formData.ircaseid);
                }

            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        changeIRCaseHandler(id) {
            var item = this.caseIDItems.find(item => item.id === id);
            this.formData.shortdesc = item.shortdesc;
            this.formData.longdesc = item.longdesc;
            this.formData.incidentdate = moment(item.incidentdate).format("DD-MM-YYYY");
        },

        async printHandler(data) {
            const vm = this;
            const id = data.templatetypeid;
            vm.isPrint = true;

            const showDate = new Date().toISOString().slice(0, 10);
            const res = await this.$store.dispatch('get', { url: "/letter/" + id });

            if (res.status !== 200 || !res.data.rec[0] || !res.data.rec[0].detail) {
                vm.isErr = true;
                return;
            }

            const templatePages = res.data.rec[0].detail;



            for (let recordIndex = 0; recordIndex < vm.letterTemplateDetails.length; recordIndex++) {
                const record = vm.letterTemplateDetails[recordIndex];

                // Create new PDF for this record
                const doc = new jsPDF('p', 'pt', 'letter');
                doc.canvas.height = 72 * 11;
                doc.canvas.width = 72 * 8.5;

                for (let pageIndex = 0; pageIndex < templatePages.length; pageIndex++) {
                    let e = templatePages[pageIndex];
                    let cntnt = e.content;

                    // Replace tokens
                    cntnt = cntnt.replaceAll(`{{CURDATE()}}`, showDate);
                    Object.keys(record).forEach(key => {
                        cntnt = cntnt.replaceAll(`{{${key}}}`, record[key] || '');
                    });

                    if (vm.classId === 1) {
                        if (pageIndex === 0) {
                            vm.emailHandler(data.subject, cntnt);
                        }
                        continue;
                    }

                    // Wait for fromHTML to finish rendering before continuing
                    await new Promise((resolve) => {
                        doc.fromHTML(cntnt, 50, 30, { width: 520 }, () => {
                            if (pageIndex < templatePages.length - 1) {
                                doc.addPage();
                            }
                            resolve();
                        });
                    });
                }

                // Open in a new tab using a Blob to avoid overwriting
                if (vm.classId !== 1) {
                    const blob = doc.output('blob');
                    const blobUrl = URL.createObjectURL(blob);
                    window.open(blobUrl, '_blank');
                }
            }
        },

                
        updateValue() {
            for (let i = 0; i < this.formData.casesubdetail.length; i++) {
                if (this.formData.casesubdetail[i].termination === 'N') {
                    this.formData.casesubdetail[i].termination = false
                } else {
                    this.formData.casesubdetail[i].termination = true
                }

                if (this.formData.casesubdetail[i].salsuspension === 'N') {
                    this.formData.casesubdetail[i].salsuspension = false
                } else {
                    this.formData.casesubdetail[i].salsuspension = true
                }

                if (this.formData.casesubdetail[i].svsuspension === 'N') {
                    this.formData.casesubdetail[i].svsuspension = false
                } else {
                    this.formData.casesubdetail[i].svsuspension = true
                }
            }
            this.$emit('input', {
                id: this.formData.id,
                casesubdetail: this.formData.casesubdetail,
                ircaseid: this.formData.ircaseid,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.updateValue();
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },
        
        cancelHandler() {
            this.$router.push({name: 'casesubmaintenancelist', params: { search: this.search}});
        },

        loadLetterTemplateDetails(){
            const vm = this;
            this.$store.dispatch('get', {url: '/irlettertemplate/' + vm.formData.id})
            .then(res => {
                if (res.data.rec.length == 0) return false
                    vm.letterTemplateDetails = res.data.rec; 

                    vm.letterTemplateDetails.forEach(item => {
                        if (item.salsuspstartdate) {
                            item.salsuspstartdate = moment(item.salsuspstartdate).format("DD-MM-YYYY");
                        }
                        if (item.salsuspenddate) {
                            item.salsuspenddate = moment(item.salsuspenddate).format("DD-MM-YYYY");
                        }
                        if (item.svsuspstartdate) {
                            item.svsuspstartdate = moment(item.svsuspstartdate).format("DD-MM-YYYY");
                        }
                        if (item.svsuspenddate) {
                            item.svsuspenddate = moment(item.svsuspenddate).format("DD-MM-YYYY");
                        }
                        if (item.effectivedate) {
                            item.effectivedate = moment(item.effectivedate).format("DD-MM-YYYY");
                        }
                        if (item.didate) {
                            item.didate = moment(item.didate).format("DD-MM-YYYY");
                        }
                    });
            })
            .catch(err => {
                vm.errMsg = err;
            });
        }
    },

    mounted(){
        console.log('formdata', this.formData)
        this.loadCaseID();
        this.loadLetterTemplateDetails();
    }
}
</script>